import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url';
import mapStyles from './mapStyles';

export const COMMENT_MAP_CONFIG = {
	libraries: ['places'] as Libraries,

	mapContainerStyle: {
		height: '550px',
		width: '100%',
		borderRadius: '4px',
		border: '30px solid white',
	},

	options: {
		styles: mapStyles,
		disableDefaultUI: true,
		zoomControl: true,
		minZoom: 7,
		panControl: true,
	},

	defaultCoordinates: {
		lat: 33.957849,
		lng: -30.667122,
	},
};
